/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ExtendedContextName = 'connections' | 'files' | 'social_group' | 'comments' | 'account_related' | 'category_related';

export const ExtendedContextName = {
    Connections: 'connections' as ExtendedContextName,
    Files: 'files' as ExtendedContextName,
    SocialGroup: 'social_group' as ExtendedContextName,
    Comments: 'comments' as ExtendedContextName,
    AccountRelated: 'account_related' as ExtendedContextName,
    CategoryRelated: 'category_related' as ExtendedContextName
};